import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import ReactionChip from '../chips/ReactionChip';
import type { ElementReactionChipDescriptor } from '../elementChipsTypes';
import type { TaskItemReaction } from '../../../../common/tiptap/extensions/taskList/taskListItemChipTypes';
import type { UpdateTaskItemAttrs } from '../taskItemChipsUtils';
import { createReactionState } from '../../../../common/chips/reactionUtils';
import { deselectElementChip } from '../elementChipsActions';

type TaskItemReactionChipProps = {
    chip: ElementReactionChipDescriptor;
    currentUserId?: string;
    reactions: TaskItemReaction[];
    updateAttributes: UpdateTaskItemAttrs;
    canModify: boolean;
};

/**
 * Reaction chip for a Tiptap task item: presses toggle the current user's row
 * in the owning node's `reactions` attr.
 */
const TaskItemReactionChip: React.FC<TaskItemReactionChipProps> = ({
    chip,
    currentUserId,
    reactions,
    updateAttributes,
    canModify,
}) => {
    const dispatch = useDispatch();

    const onPress = useCallback(
        (emojiCode: string) => {
            if (!canModify || !currentUserId) return;

            dispatch(deselectElementChip());
            updateAttributes({
                reactions: createReactionState({
                    existingReactionState: reactions,
                    emojiCode,
                    userId: currentUserId,
                }),
            });
        },
        [canModify, currentUserId, dispatch, reactions, updateAttributes],
    );

    return (
        <ReactionChip
            chip={chip}
            currentUserId={currentUserId}
            canModify={canModify}
            onPress={() => onPress(chip.emojiCode)}
        />
    );
};

export default TaskItemReactionChip;
